import jsPDF from 'jspdf'
import { applyPlugin } from 'jspdf-autotable'

// jspdf-autotable 5 no longer patches jsPDF on import. applyPlugin restores doc.autoTable and
// jsPDF.autoTableSetDefaults, which this file and the invoice parts still use.
applyPlugin(jsPDF)

import imageHeaderSection from './invoiceParts/imageHeaderSection'
import imageTextSection from './invoiceParts/imageTextSection'
import quoteHeaderSection from './invoiceParts/quoteHeaderSection'
import quoteHeaderTextSection from './invoiceParts/quoteHeaderTextSection'
import clientInfoAndNotesSection from './invoiceParts/clientInfoAndNotesSection'
import quoteSection from './invoiceParts/quoteSection'

export default class InvoiceGenerator {
  generate(job, preview) {
    var doc = new jsPDF({ unit: 'px', compress: true })
    doc.setProperties({
      title: job.jobNumber + '-invoice.pdf',
    })

    jsPDF.autoTableSetDefaults(
      {
        headStyles: { fillColor: '#f05353', textColor: '#ffffff' },
      },
      doc
    )

    let docData = { doc, job, yAxis: 3, buffer: 10 }

    imageHeaderSection(docData)
    imageTextSection(docData)
    quoteHeaderSection(docData)
    quoteHeaderTextSection(docData)
    clientInfoAndNotesSection(docData)
    quoteSection(docData)

    if (preview === true) {
      window.open(docData.doc.output('bloburl'))
    } else {
      docData.doc.save(job.jobNumber + '-invoice.pdf')
    }
  }
}
